import ConfirmModal from "server/components/Modals/ConfirmModal";

// Only the link to this curriculum goes; the nomenclature entry is untouched.
const DeleteItemDialog = ({ title = "Изтриване", itemLabel, onConfirm, triggerButton }) => (
  <ConfirmModal
    titleContent={title}
    triggerButton={triggerButton}
    message={
      itemLabel
        ? `Сигурни ли сте, че искате да изтриете „${itemLabel}“ от този учебен план?`
        : "Сигурни ли сте, че искате да изтриете записа от този учебен план?"
    }
    saveTitle="Изтрий"
    onConfirm={onConfirm}
  />
);

export default DeleteItemDialog;
